import FullscreenLoader from "@/components/fullscreen-loader";
import { usePermission } from "@/hooks/use-premission";
import { useGetActiveSubscriptionPlans } from "@/hooks/use-subscription";
import { PermissionValues } from "@/pages/role/constants";
import { Navigate, useRouterState } from "@tanstack/react-router";

interface PermissionWrapperProps {
  children: React.ReactNode;
}

const routePermissions: Record<string, PermissionValues | PermissionValues[]> =
  {
    "/role": "roles:view",
    "/team-manage": "team:view",
    "/postmaster": "postmaster:view",
    "/placement-test": "inbox_placement:view",
    "/seed-list": "seed_list:view",
    "/labels": "labels:view",
    "/integration": ["integration:view", "api_access:view"],
    "/mailboxes": "mailboxes:view",
    "/email-health": "email_health:view",
    "/email-health/email-health-test": "email_health:run_test",
    "/templates": "templates:view",
    "/templates/editor": ["templates:edit", "templates:create"],
  };

const newOnboardingAllowedRoutes = ["/plans", "/profile"];

export function PermissionWrapper({ children }: PermissionWrapperProps) {
  const { isLoading, hasPermission } = usePermission();
  const { data: activeSubscriptionPlans } = useGetActiveSubscriptionPlans();
  const state = useRouterState();
  const { pathname } = state.location;

  const hasActiveSubscription =
    activeSubscriptionPlans && activeSubscriptionPlans.length > 0;

  if (isLoading) {
    return <FullscreenLoader />;
  }

  // if (pathname !== "/plans" && !hasActiveSubscription) {
  //   return <Navigate to="/plans" />;
  // }

  const permission = routePermissions[pathname];
  if (!permission) {
    return <>{children}</>;
  }

  const hasAccess = hasPermission("organization:admin") || (Array.isArray(permission)
    ? permission.some(hasPermission)
    : hasPermission(permission));

  return hasAccess ? <>{children}</> : <Navigate to="/" />;
}
